module.exports = __webpack_public_path__ + "2e1f15f9914eac7a8d0b7b49c9f06640.svg";